import vFade from "./v-fade.vue";

export default Vue => {
  Vue.component("v-fade", vFade);
};
